<template>
  <div class="shop-wrapper">
    <v-head></v-head>
    <div class="flex-row">
      <div class="sidebar">
        <el-menu
          v-if="items.length"
          class="sidebar-el-menu"
          @select="handleSelect"
          background-color="#fff"
          text-color="#111"
          active-text-color="#3388FF"
          unique-opened
          router
        >
          <template v-for="item in items">
            
            <el-menu-item
              class="el-menu-item"
              :class="isSelected == item.url?'active':''"
              :index="item.url"
              :key="item.id"
              :route="{path: item.url}"
              v-if="item.hide"
            >
              <template slot="title">
                <!-- <i :class="item.icon" class="icon"></i> -->
                <!-- <img src="../../../assets/images/data/sms.png" alt="" class="icon"> -->
                <!-- <img :src="item.iconUrl" alt="" class="icon"> -->
                <span class="text">{{ item.name }}</span>
              </template>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      
      <div class="content-box flex1" :class="{'content-collapse':collapse}">
        <div
          class="content fff"
          v-loading.fullscreen.lock="$store.state.loading"
          element-loading-text="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <transition name="move" mode="out-in">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" class="page"></router-view>
            </keep-alive>
          </transition>
          <transition name="move" mode="out-in">
            <router-view class="page" v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vHead from "../../../components/common/Header.vue";
export default {
  data() {
    return {
      collapse: false,
      isRouterAlive: true,
      items: [
        {
          name: '门店服务',
          url: '/manage/shopServeed',
          hide: true
        },
        {
          name: '短信统计',
          url: '/manage/smsSendTotal',
          authKey: 'shopServe',
          auth: 'shopServe:statistics',
          hide: true
        },
      ],
      isSelected: '/manage/shopServeed'
    };
  },
  components: {
    vHead
  },
  created () {
    let permissions = JSON.parse(localStorage.getItem('permissions'))
    this.items.map(item => {
      if (permissions && permissions.hasOwnProperty(item.authKey)) {
        let arr = permissions[item.authKey]
        let index = arr.findIndex(it => it === item.auth)
        if (index > -1) {
          item.hide = true
        } else {
          item.hide = false
        }
      }
    })
    console.log(this.$route)
    this.isSelected = this.$route.path
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key);
      this.isSelected = key;
    },
  },
  watch: {
    '$route' (val) {
      console.log(val);
      if (val.fullPath == '/manage/shopServeed?type=sms') {
        this.isSelected = val.path
      }
    }
  }
};
</script>
<style lang="less" scoped>
.content-box {
  padding-left: 161px;
}

.flex1 {
  flex: 1;
}
.sidebar {
  background: #fff;
  display: block;
  position: absolute;
  left: 0;
  top: 58px;
  bottom: 0;
  z-index: 9;
  overflow: auto;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  /* width: 186px; */
  width: 160px;
}

.sidebar > ul {
  height: 100%;
}

.show-ellipsis {
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.show-ellipsis ::after {
  content: "...";
}
.el-menu-item {
  height: 54px;
  // line-height: 40px;
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 20px;
  color: #111;
  margin-bottom: 10px;
  &:hover {
    color: #fff !important;
    background: #3388FF !important;
  }

  .icon {
    width: 24px;
    height: 24px;
    margin-right: 5px;
  }
}
.sidebar .active {
  color: #fff !important;
  background: #3388FF !important;
}
.sidebar /deep/ .is-active {
  // color: rgb(17, 17, 17) !important;
  color: #111 !important;
  background-color: rgb(255, 255, 255);
}
</style>